import React , {useState , useEffect} from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import { useNavigate } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
//
import Terminos from './Terminos';
//

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
//
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
//
function RegistroComercio() {
        const [calle,setCalle] = useState('');
        const [numero,setNumero] = useState('');
        const [socio, setSocio] = useState(false);
        const [cuit,setCuit] = useState('');
        const [razonsocial,setRazonsocial] = useState('');
        const [email,setEmail] = useState('');
        const [contacto,setContacto] = useState('');
        const [web,setWeb] = useState('');
        const [whatsapp,setWhatsapp] = useState('');
        const [msgok,setMsgok] = useState(false); 
        const [openError,setOpenError] = useState(false); 
        const [showAlert, setShowAlert] = useState(false);
        const navigate = useNavigate() ;
        const [open, setOpen] = React.useState(false);

        const handleClickOpen = () => {
          setOpen(true);
        };
        const handleClose = () => {
          setOpen(false);
          volver();
        };
            
        // funciones
       
        const handleCloseAlert = (estado) => {
          setShowAlert(estado);
        };
        
        const handleError = () => {
          setOpenError(false);
        };
        const handleChange = (event) => {
            setSocio(event.target.value);
          };
    
        const handleSubmit = async (event) => {
          
            event.preventDefault();
            //
            const postData = {
                nombredefantasia : '',//nombredefantasia,
                cuit : cuit,
                razonsocial : razonsocial,
                calle : calle,
                numero : numero,
                email : email,
                contacto : contacto,
                socioucip : socio,
                aprobacion : false,
                fecha_alta : new Date(),
                fecha_aprobacion : new Date(),
                detalle_aprobacion : '',
                idrubro : -1,
                web : web,
                whatsapp : whatsapp
                };
                //
                try {
                    const baseURL = process.env.REACT_APP_SERVER_PATH + 'addComercio';
                    const res = await fetch(`${baseURL}`, {
                       
                      method: "post",
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": "token-value",
                        'Access-Control-Allow-Origin': '*'
                      },
                      body: JSON.stringify(postData),
                    });
                    console.log('status: '+res.status);
                    if (res.status === 200 ||res.status === 204) {
                      //setMsgok(true); //                      setNombredefantasia('');
                      setCuit('');
                      setRazonsocial('');
                      setCalle('');
                      setNumero('');
                      setEmail('');
                      setContacto('');
                      setSocio('');
                      setWeb('');
                      setWhatsapp('');
                      setOpen(true);
                      /*
                      setTimeout(() => {
                      volver(); 
                      }, 9000);
                      // ir al panel comercio y avisar que debe crear domicilios
                      */
                    } else
                    if (res.status === 505) 
                     {
                      setOpenError(true);
                     }

                        } catch (err) {
              console.log(err.message)
                  }
                //
          };
          const volver = () => {
            navigate('/')
            
          }  

          useEffect( () => {
                   //getCentrosComerciales(); 
                   //getRubros();
     
        },[])
  return (
    <div>

    <Container component="main" maxWidth="md">
        <Box component="form" 
              sx={{
                width: '100px', // Establece el ancho deseado para tu div
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
              onSubmit={handleSubmit}>
            <Button variant="contained" color="secondary" onClick={()=>handleClose()}>Imprimir QR</Button>
        </Box>
    </Container>
</div>
  )
}

export default RegistroComercio
